import { useNotes_AssignIndicationNoteMutation } from '../graphql';

// `Notes_IndicationNoteQuery` uses `fetchPolicy: 'no-cache'`, and Apollo Client does not
// reliably refetch no-cache queries via `refetchQueries` (by name or by document+variables —
// see https://github.com/apollographql/apollo-client/issues/8788). The notes list is refreshed
// explicitly via that query's own `refetch()` in Notes.tsx instead.
export const useAssignNoteMutation = (
  options: Parameters<typeof useNotes_AssignIndicationNoteMutation>[0] = {}
) => {
  return useNotes_AssignIndicationNoteMutation(options);
};
